import { useUsers } from '$tablet-app/src/app/users';
import { getId } from '@akin-home/records';

import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import React, { FC, useEffect } from 'react';
import { getAppLockedProfileID } from '../../functions/getAppIsLocked';
import { ForgotPINDialog } from '../ForgotPINDialog';
import { LockScreen } from '../LockScreen';
import { LockScreenOverlay } from '../LockScreenOverlay';

/** This component should wrap the main authenticated app and show whenever the app is locked */
const LockScreenProvider: FC<{ children: React.ReactNode }> = (props) => {
  const users = useUsers();
  const visible = useStateStore((state) => state.lock_screen.visible);
  const locked_user_id = useStateStore((state) => state.locked_user_id);
  const forgotPin = useStateStore((state) => state.lock_screen.forgotPin);
  const lock = useStateStore((state) => state.lockApp);

  const user = users?.find((u) => u.id === locked_user_id);

  /** When the app loads, check if it is currently locked */
  useEffect(() => {
    getAppLockedProfileID({ profile_ids: users?.map(getId) || [] }).then(
      (user_id) => {
        user_id && lock(user_id);
      }
    );
  }, [users]);

  return (
    <>
      {props.children}

      <LockScreenOverlay visible={visible}>
        <LockScreen />
      </LockScreenOverlay>

      {user ? (
        <ForgotPINDialog email={user.email} onPressConfirm={forgotPin} />
      ) : null}
    </>
  );
};

export default LockScreenProvider;
